export type ValueOrFunction<T> = T | ((...args: any) => T) | undefined

export function getValueFromFunction<T>(valOrFunc: ValueOrFunction<T>, ...args: any): T | undefined {
	if (typeof valOrFunc == 'undefined') return undefined
	return typeof valOrFunc === 'function' ? (valOrFunc as (...args: any) => T)(...args) : (valOrFunc as T)
}
